import React, { useEffect, useState } from 'react';
import classNames from 'classnames';
import { FormGroup } from 'components/common/Forms';
import DatePicker from 'react-datepicker';
import { compose, withHandlers, withState } from 'recompose';
import moment from 'moment';
import classnames from 'classnames';
import { cloneDeep } from 'lodash';

export const DateRange = ({
  fromDate,
  onFromDateChange,
  toDate,
  onToDateChange,
  className,
  dateFormat = 'YYYY-MM-DD',
  filters,
  setFilters,
  // onRawFromDateChange,
  // onRawToDateChange,
  // toDateValid,
  // setToDateValid,
  // fromDateValid,
  // setFromDateValid,
  ...props
}) => {
  const [ toDateValid, setToDateValid ] = useState(true);
  const [ fromDateValid, setFromDateValid ] = useState(true);

  function setFromDate(date){
    console.log({date});
    let temp = cloneDeep(filters);
    temp['from_date'] = date;

    console.log({temp});
    setFilters(temp);
  }

  function onRawFromDateChange(v){
    try {
      moment(v, dateFormat);
      setFromDateValid(true);
      setFilters({
        ...filters,
        from_date: v,
      });
    } catch (error) {
      console.warn({error});
      setFromDateValid(false);
    }
  }

  function onRawToDateChange(v){
    try {
      moment(v, dateFormat);
      setToDateValid(true);
      setFilters({
        ...filters,
        to_date: v,
      });
    } catch (error) {
      console.warn({error});
      setToDateValid(false);
    }
  }

  useEffect(() => {
    if(filters){
      console.log({filters});
    }
  }, [ filters ])

  useEffect(() => {
    if(fromDate){
      console.log({fromDate});
    }
  }, [ fromDate ])

  return(
    <div className='d-flex mr-2' {...props}>
      <FormGroup className="row" style={{marginRight: '0px', marginLeft: '0px'}}>
        <div className="mt-auto mb-auto mr-2"> From </div>
        <div style={{width:'110px'}}>
          <DatePicker
            className={classnames('form-control', { 'has-danger': !fromDateValid })}
            selected={filters && filters.from_date ? moment(filters.from_date) : fromDate}
            selectsStart
            onSelect={(v) =>
              setFilters({
                ...filters,
                from_date: v,
              })
            }
            onChangeRaw={e => onRawFromDateChange(e.target.value)}
            startDate={fromDate}
            endDate={toDate}
            dateFormat={dateFormat}
          />
        </div>
        {!fromDateValid && (
          <span className="small text-danger form-text">
            Date must be in the format "{moment().format(dateFormat)}"
          </span>
        )}
      </FormGroup>
      <FormGroup className="row" style={{marginRight: '0px', marginLeft: '0px'}}>
        <div className="ml-2 mt-auto mb-auto mr-2"> To </div>
        <div style={{width:'110px'}}>
          <DatePicker
            className={classnames('form-control', { 'has-danger': !toDateValid })}
            selected={filters && filters.to_date ? moment(filters.to_date) : toDate}
            selectsEnd
            onSelect={(v) =>
              setFilters({
                ...filters,
                to_date: v,
              })
            }
            onChangeRaw={e => onRawToDateChange(e.target.value)}
            startDate={fromDate}
            endDate={toDate}
            dateFormat={dateFormat}
          />
        </div>
        {!toDateValid && (
          <span className="small text-danger form-text">
            Date must be in the format "{moment().format(dateFormat)}"
          </span>
        )}
      </FormGroup>
    </div>
  )
}

// const enhance = compose(
//   withState('toDateValid', 'setToDateValid', true),
//   withState('fromDateValid', 'setFromDateValid', true),
//   withHandlers({
//     setFromDate: ({ filters, setFilters }) => date => {
//       console.log({date})
//       setFilters({
//         ...filters,
//         from_date: date,
//       });
//     }
//   }),
//   withHandlers({
//     onRawFromDateChange: ({
//       onFromDateChange,
//       dateFormat,
//       setFromDateValid,
//       filters,
//       setFilters,
//       setFromDate,
//     }) => v => {
//       try {
//         moment(v, dateFormat);
//         setFromDateValid(true);
//         onFromDateChange(v);
//         setFromDate(v);
//       } catch (error) {
//         console.warn({error})
//         setFromDateValid(false);
//       }
//     },
//     onRawToDateChange: ({
//       onToDateChange,
//       dateFormat,
//       setToDateValid,
//       filters,
//       setFilters,
//     }) => v => {
//       try {
//         moment(v, dateFormat);
//         setToDateValid(true);
//         onToDateChange(v);
//         setFilters({
//           ...filters,
//           to_date: v,
//         });
//       } catch (error) {
//         setToDateValid(false);
//       }
//     },
//   })
// );
//
// export default enhance(DateRange);

export default DateRange;



// WEBPACK FOOTER //
// ./src/components/common/Tables/DateRange.jsx